<template>
  <section
      :class="{ 'is-highlight': highlight }"
      class="lp-panel-card">
    <slot name="heading">
      <header class="lp-panel-card__head">
        <span
            :class="{ 'is-open': open }"
            class="lp-panel-card__icon">
          <icon
              v-if="icon"
              :name="icon"/>
        </span>
        <span class="lp-panel-card__title">{{ title }}</span>
        <slot name="actions">
          <span
              v-if="badge"
              class="lp-panel-card__badge">{{ badge }}</span>
        </slot>
      </header>
    </slot>
    <div class="lp-panel-card__body">
      <slot/>
    </div>
  </section>
</template>

<script>
export default {
  name:  'PanelCard',
  props: {
    title:     { type: String, default: '' },
    icon:      { type: String, default: '' },
    badge:     { type: String, default: '' },
    open:      { type: Boolean, default: true },
    highlight: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/lp-tokens';

.lp-panel-card {
  margin: 4px 8px;
  border: 1px solid $lp-line;
  border-radius: $lp-radius-panel;
  background-color: $white;
  box-shadow: 0 1px 2px rgba(20, 22, 27, 0.04);

  &.is-highlight {
    border-color: rgba($lp-accent, 0.4);
    box-shadow: 0 0 0 3px rgba($lp-accent, 0.06);
  }
}

.lp-panel-card__head {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 12px 8px;
}

.lp-panel-card__icon {
  display: flex;
  flex: 0 0 32px;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: $lp-radius-tile;
  background-color: $lp-fill;
  color: $lp-ink-2;

  &.is-open {
    background-color: $lp-accent;
    color: $white;

    ::v-deep svg [stroke]:not([stroke="none"]) {
      stroke: currentColor;
    }
  }
}

.lp-panel-card__title {
  flex: 1 1 auto;
  min-width: 0;
  font-family: $lp-sans;
  font-size: $lp-fs-title;
  font-weight: 600;
  color: $lp-ink;
}

.lp-panel-card__badge {
  padding: 3px 10px;
  border-radius: 999px;
  background-color: $lp-accent-soft;
  font-size: $lp-fs-control;
  font-weight: 500;
  color: $lp-accent-ink;
  white-space: nowrap;
}

.lp-panel-card__body {
  padding: 0 16px 16px;
}
</style>
